import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { Tooltip } from 'antd';

export default function B() {
    const { useLang, useState, useRouter, Link } = useGlobal();
    const { t } = useLang('costsaving');
    const { locale } = useRouter();
    const cards: any = [
        {
            img: locale==='za' ? 'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719537450067/Frame%20161269315.jpg' :  `/responsive/picture/cost-saving/2_1`,
            title: t('secB_card1_title'),
            desc: t('secB_card1_desc'),
            link: t('secB_card1_link'),
            target: '#cost-saving-C',
            showQuestion: t('secB_card1_question'),
        },
        {
            img: locale==='za' ? 'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719537464612/Frame%20161269316.jpg' : `/responsive/picture/cost-saving/2_2`,
            title: t('secB_card2_title'),
            desc: t('secB_card2_desc'),
            link: t('secB_card2_link'),
            target: '#cost-saving-E',
            showQuestion: t('secB_card2_question'),
        },
    ];

    return (
        <div id="cost-saving-B" className={`cost-saving-B cost-saving-box ${css['cost-saving-B']}`}>
            <div className="text-info">
                <h2 className="title">{t('secB_title')}</h2>
                <p className="desc">{t('secB_desc')}</p>
            </div>
            <ul className="cards">
                {cards?.map((card: any, k: number) => (
                    <li className="card" key={k}>
                        <div className="card-img">
                            <EFPicture src={`${card?.img}${locale === 'za' ? '' : '.jpg'}`} srcPad={`${locale === 'za' ? card?.img : `${card?.img}_768.jpg`}`} srcMobile={`${locale === 'za' ? card?.img : `${card?.img}_768.jpg`}`} alt={card?.title} />
                        </div>
                        <div className="card-info">
                            <p className="card-title">{card?.title}</p>
                            <p className="card-desc text">
                                {card?.desc}
                                {card?.showQuestion && <Tooltip 
                                    className="question" 
                                    title={card?.showQuestion} 
                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                    // placement="bottom"
                                    trigger='click'
                                >
                                    ?
                                </Tooltip>}
                            </p>
                            <a className="card-link" href={card?.target}>
                                <span className="link-text">{card?.link}</span>
                                <span className="link-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12.0031 21.2C9.46286 21.2 7.16287 20.1701 5.49794 18.5051C3.83301 16.8402 2.80312 14.5402 2.80312 12C2.80312 9.45969 3.83301 7.1597 5.49794 5.49477C7.16287 3.82984 9.46286 2.79995 12.0031 2.79995C14.5434 2.79995 16.8434 3.82984 18.5083 5.49477C20.1732 7.1597 21.2031 9.45968 21.2031 12C21.2031 14.5402 20.1732 16.8402 18.5083 18.5051C16.8434 20.1701 14.5434 21.2 12.0031 21.2Z"
                                            stroke="#3F68E0"
                                            strokeWidth="1.7"
                                        />
                                        <path
                                            d="M16 12L12 16L8 12M12 14.5L12 7.99997"
                                            stroke="#3F68E0"
                                            strokeWidth="1.7"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                            </a>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
